<template>
<div>
  <w-search-field ref="searchField" v-if="showSearchTool === true" class="title-bar" :width="searchWidth" @search="filterTree"/>
  <el-tree ref="tree"
    :data="treeData"
    :props="defaultProps"
    node-key="treeKey"
    @node-click="onClickNode"
    @check-change="onCheckChange"
    :filter-node-method="filterNode"
    default-expand-all
    :expand-on-click-node="false"
    highlight-current
    :force-select-leaf="forceSelectLeaf"
    draggable :allow-drag="allowDrag" :allow-drop="allowDrop"
    >
    <span class="el-tree-node__label" slot-scope="{ node, data }">
      <span v-if="!showEditIcon && data.type !== 'obj'">
        <span>{{data.label}}</span>
      </span>
      <span v-else-if="data.type === 'root'" >
        <span class="tree-node-edit-icon mini content-margin-r">
          <span class="icon-margin-r"><i class="far fa-plus-circle" @click="addDomain"></i></span>
        </span>
        <span>{{data.label}}</span>
      </span>
      <span v-else-if="data.type === 'domain'">
        <span>
          <span class="tree-node-edit-icon mini content-margin-r">
            <span class="icon-margin-r"><i class="far fa-pen" @click="editDomain(data)"></i></span>
            <span class="icon-margin-r"><i class="far fa-plus-circle" @click="addGroupInfo(data)"></i></span>
            <span v-if="data.domainId !== 1"><i class="far fa-minus-circle" @click="deleteDomain"></i></span>
          </span>
          <span>{{data.label}}</span>
        </span>
      </span>
      <span v-else-if="data.type === 'group'">
        <span>
          <span class="tree-node-edit-icon mini content-margin-r" v-if="isBasicGroup(data)">
            <span class="icon-margin-r"><i class="far fa-pen" @click="updateGroupInfo(data)"></i></span>
            <span><i class="far fa-minus-circle" @click="deleteGroup"></i></span>
          </span>
          <span>{{data.label}}</span>
        </span>
      </span>
      <span v-else-if="data.type === 'obj'">
        <span><i class="fas fa-browser"></i><span class="mr-l4">{{data.label}}</span></span>
      </span>
      <span v-else>
        <span>{{data.label}}</span>
      </span>
    </span>
  </el-tree>
  <w-domain-setting-popup ref="domainSettingPopup" :popupOpenNode="domainNode" :popupType="domainSettingPopupType" @reload="loadData"></w-domain-setting-popup>
  <w-group-setting-popup ref="groupSettingPopup" :popupOpenNode="popupOpenNode" :currentTreeType="currentTreeType" @reload="loadData"></w-group-setting-popup>
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import clone from 'lodash/clone';
import isNil from 'lodash/isNil';
import cloneDeep from 'lodash/cloneDeep';
import msgUtil from '@/utils/message';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';
import TreeFilter from '@/mixins/tree/filter';
import { findFirstLeafTreeKey, getPathNodes, isObjNode, isRequireIPObjType, getObjNodeLabel } from '@/utils/tree';
import { defaultProps } from '@/constants/tree';
import WSearchField from '@/components/form/SearchField';
import WDomainSettingPopup from '../popup/DomainSettingPopup';
import WGroupSettingPopup from '../popup/GroupSettingPopup';

const treetype = { keyTrs: '비즈니스', application: '티어', instance: '티어' };

// 해당 코드에서 group은 (비즈니스, 티어)의 개념을 나타낸다.
// ex) deleteGroup => 비즈니스,티어 삭제
//      addGroupInfo => 비즈니스, 티어 추가
//      updateGroupInfo => 비즈니스, 티어 수정
export default {
  name: 'WApmTree',
  components: {
    WSearchField,
    WDomainSettingPopup,
    WGroupSettingPopup,
  },
  mixins: [TreeFilter],
  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    currentTreeType: {
      type: String,
    },
    forceSelectLeaf: {
      type: Boolean,
      default: false,
    },
    managetypeId: {
      type: String,
      default: null,
    },
    showSearchTool: {
      type: Boolean,
      default: true,
    },
    searchWidth: {
      type: String,
      default: '95%',
    },
    includeRoot: {
      type: Boolean,
      default: true,
    },
    backButtonInfo: {
      type: Object,
      default: () => ({}),
    },
    isGroupTree: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      treeRef: 'tree',
      showEditIcon: false,
      selectedNode: null,
      popupOpenNode: {},
      domainNode: {},
      treeData: null,
      defaultTreeData: null,
      domainSettingPopupType: '',
      groupSettingPopupType: '',
      defaultProps,
    };
  },
  watch: {
    isEditMode: {
      handler() {
        if (!isNil(this.isEditMode)) {
          this.showEditIcon = this.isEditMode;
        }
      },
      immediate: true,
    },
    currentTreeType: {
      handler() {
        if (!isNil(this.currentTreeType)) {
          this.$emit('changeTreeType');
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    isObjNode,
    isRequireIPObjType,
    getObjNodeLabel,
    loadData() {
      const me = this;
      ApmSettingAPI.getGroupTreeByType({ currentTreeType: this.currentTreeType, includeRoot: this.includeRoot, isGroupTree: this.isGroupTree }).then((response) => {
        if (response.data.success) {
          me.treeData = response.data.children;
          this.defaultTreeData = cloneDeep(response.data.children);
          this.$nextTick(() => {
            let selectedNode;
            const root = this.$refs.tree.getNode('1');
            const treeKey = findFirstLeafTreeKey(root);
            if (treeKey === null) {
              selectedNode = root;
            } else {
              selectedNode = this.$refs.tree.getNode(treeKey) || root;
            }
            // 그룹 트리인지 노드 트리인지에 따라 선택되어야 하는 노드가 다름
            if (!isEmpty(selectedNode)) {
              const pathNodes = getPathNodes(selectedNode);
              pathNodes.forEach((item) => {
                if (!item.isLeaf) {
                  item.expanded = true;
                }
              });
              if (this.isGroupTree) {
                if (!isEmpty(this.backButtonInfo.currentNodeInfo)) {
                  this.selectedNode = this.backButtonInfo.currentNodeInfo;
                  this.$refs.tree.setCurrentKey(this.backButtonInfo.currentTreekey);
                } else {
                  this.selectedNode = selectedNode;
                  this.$refs.tree.setCurrentKey(selectedNode.data.treeKey);
                }
                if (!isEmpty(this.backButtonInfo.currentNodeInfo)) {
                  const nodeInfo = this.backButtonInfo.currentNodeInfo;
                  nodeInfo.backbtnFlag = true;
                  this.$emit('clickNode', nodeInfo);
                } else {
                  this.$emit('clickNode', selectedNode.data);
                }
              } else {
                const childNodes = root.childNodes;
                const selectTreeKey = this.existChildNode(childNodes);
                if (!isNil(selectTreeKey)) {
                  this.selectedNode = childNodes[0];
                  this.$refs.tree.setCurrentKey(selectTreeKey);
                  this.$emit('clickNode', childNodes[0].data);
                }
              }
            }
          });
        }
      });
    },
    /**
     * [existChildNode 도메인 생성시 경보는 자동으로 설정되기 때문에 도메인을 선택하도록 설정한다.]
     * @author yelim
     */
    existChildNode(node) {
      let selectTreeKey;
      if (node && node.length > 0) {
        selectTreeKey = node[0].data.treeKey;
      }
      return selectTreeKey;
    },
    getTree() {
      return this.$refs.tree;
    },
    getCurrentNode() {
      return this.$refs.tree.getCurrentNode() || this.selectdNode.data;
    },
    allowDrag(draggingNode) {
      // root node이거나 편집 중 일때는 drag를 못하게 한다.
      if (this.isEditMode === false) {
        return false;
      } else if (draggingNode.data.type !== 'group') {
        return false;
      }
      return true;
    },
    allowDrop(draggingNode, dropNode, dropType) {
      // drop node가 root node일 경우 하위 추가만 가능하도록 한다.
      // drop.depth!=2
      if (draggingNode.data.type === 'domain' && dropNode.data.type === 'group' && dropType !== 'inner') {
        return false;
      } else if (draggingNode.data.type === 'domain' && dropNode.data.type === 'group' && dropType === 'inner') {
        return false;
      } else if (draggingNode.data.type === 'domain' && dropNode.data.type === 'domain' && dropType !== 'inner') {
        return false;
      } else if (draggingNode.data.type === 'domain' && dropNode.data.type === 'domain' && dropType === 'inner') {
        return false;
      } else if (draggingNode.data.type === 'group' && dropNode.data.type === 'group' && dropType !== 'inner') {
        return false;
      } else if (draggingNode.data.type === 'group' && dropNode.data.type === 'group' && dropType === 'inner') {
        return false;
      } else if ((draggingNode.data.type === 'group' || draggingNode.data.type === 'domain') && dropNode.data.type === 'root' && dropType !== 'inner') {
        return false;
      } else if ((draggingNode.data.type === 'group' || draggingNode.data.type === 'domain') && dropNode.data.type === 'root' && dropType === 'inner') {
        return false;
      } else if (draggingNode.data.type === 'group' && dropNode.data.type === 'domain' && dropType !== 'inner') {
        return false;
      }
      return true;
    },
    onClickNode(data, node) {
      // popupopen시 선택되어 있는 항목을 popupOpenNode 한다.
      this.popupOpenNode = node;
      if (this.forceSelectLeaf === true) {
        this.selectedNode = node;
        this.$emit('clickNode', data, node);
      }
    },
    onCheckChange(node, checked) {
      this.$emit('check-change', node, checked);
    },
    addDomain() {
      const emptyNode = {};
      this.domainNode = cloneDeep(emptyNode);
      this.domainSettingPopupType = 'ADD';
      this.$refs.domainSettingPopup.open();
    },
    editDomain(data) {
      this.domainNode = cloneDeep(data);
      this.domainSettingPopupType = 'MODIFY';
      this.$refs.domainSettingPopup.open();
    },
    addGroupInfo() {
      this.popupOpenNode = {};
      this.popupOpenNode.popupType = 'ADD';
      // this.groupSettingPopupType = 'ADD';
      this.$refs.groupSettingPopup.open(this.popupOpenNode);
    },
    updateGroupInfo(data) {
      this.popupOpenNode = clone(data);
      this.popupOpenNode.popupType = 'MODIFY';
      // this.groupSettingPopupType = 'MODIFY';
      this.$refs.groupSettingPopup.open(this.popupOpenNode);
    },
    deleteDomain() {
      const target = '도메인';
      const action = msgUtil.action.DELETE;
      this.$nextTick(() => {
        if (this.popupOpenNode.data.domainId === 1) {
          this.$message('기본 도메인은 삭제할 수 없습니다.');
        } else {
          this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
            ApmSettingAPI.deleteApmDomain({ domainId: this.popupOpenNode.data.domainId }).then((response) => {
              const result = response.data;
              if (result.success) {
                this.loadData();
              }
              this.$message(msgUtil.getResultMsgData(action, target, result.success));
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          });
        }
      });
    },
    deleteGroup() {
      const target = treetype[this.currentTreeType];
      const currentTreeId = this.currentTreeType;
      const action = msgUtil.action.DELETE;
      this.$nextTick(() => {
        if (currentTreeId === 'keyTrs') {
          if (this.popupOpenNode.data.bizId === 1) {
            this.$message('기본 비즈니스는 삭제할 수 없습니다.');
          } else {
            this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
              ApmSettingAPI.deleteApmBiz({ bizId: this.popupOpenNode.data.bizId }).then((response) => {
                const result = response.data;
                if (result.success) {
                  this.loadData();
                }
                this.$message(msgUtil.getResultMsgData(action, target, result.success));
              }).catch(() => {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              });
            });
          }
        } else if (currentTreeId === 'application' || currentTreeId === 'instance') {
          if (this.popupOpenNode.data.tierId === 1) {
            this.$message('기본 티어는 삭제할 수 없습니다.');
          } else {
            this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
              ApmSettingAPI.deleteApmTier({ tierId: this.popupOpenNode.data.tierId }).then((response) => {
                const result = response.data;
                if (result.success) {
                  this.loadData();
                }
                this.$message(msgUtil.getResultMsgData(action, target, result.success));
              }).catch(() => {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              });
            });
          }
        }
      });
    },
    isBasicGroup(groupInfo) {
      const currentTreeId = this.currentTreeType;
      if (currentTreeId === 'keyTrs') {
        if (groupInfo.bizId !== 1) {
          return true;
        }
      } else if (currentTreeId === 'application') {
        if (groupInfo.tierId !== 2) {
          return true;
        }
      } else if (currentTreeId === 'instance') {
        if (groupInfo.tierId !== 1) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/common/components/ApmTree.vue